export default "/_next/static/fonts/IntercomBrush-Large-caf445695fe6269e29ad10c93d4b7a00.woff2";